export default __webpack_public_path__ + "static/media/trampapo_02_15.304883e0.jpg";